const ModeOperation = Object.freeze({
    /*
     * IDE-based debugging.
     * Simulate server to board communication (over MQTT).
     *
     * App: WebStorm built-in webserver
     * Data: mosquitto MQTT
     */
    DEBUG_APP: Symbol("debug"),

    /*
     * Production!
     * Need "run build" to generate production folder
     *
     * App: Nginx + FastAPI
     * Data: MQTT
     */
    PRODUCTION_APP: Symbol("production"),
});

/*
 * Configurations
 */
const app_version = [2, 1, 1]
const modeOperation = ModeOperation.PRODUCTION_APP;


function get_remote_api() {
    if (modeOperation === ModeOperation.PRODUCTION_APP) {
        // Production. URL of the server running Nginx + FastAPI
        return "https://api.altrabits.com"
    } else if (modeOperation === ModeOperation.DEBUG_APP) {
        // Development. Pycharm-based FastAPI server
        //return "http://localhost:8000"
        //return "http://192.168.1.20:8000" // Nano
        //return "http://192.168.1.40:8000" // My computer
        return "http://192.168.1.120:8000" // My computer
    }
}


function is_debug_mode() {
    if (modeOperation === ModeOperation.DEBUG_APP) {
        return true
    } else if (modeOperation === ModeOperation.PRODUCTION_APP) {
        return false
    }
}


function get_app_name() {
    switch (modeOperation) {
        case ModeOperation.DEBUG_APP:
            return "AltraBits App (DEBUG)"

        case ModeOperation.PRODUCTION_APP:
            return "AltraBits App"
    }
}

function get_app_version() {
    return app_version
}

function get_app_version_string() {
    return app_version.join('.')
}

function get_mqtt_server_address() {
    return "mqtt.altrabits.com"
}

function get_mqtt_server_port() {
    return 9001
}

function get_public_media(path, useSize = "medium", theme = false, disableCache = false) {

    if (path) {
        const color = typeof theme === "boolean" ? theme ? "black" : "white" : theme
        const size = useSize == null ? "medium" : useSize
        const cache = disableCache ? "?nocache=" + Date.now() : ""

        // E.g., /public/media/small-black-e3420664-ec2c-403f-a711-dd5f5c2fd13f.jpg?nocache=1741607560800
        return get_remote_api() + "/public/media/" + size + "-" + color + "-" + path + cache
    }
    return null

}

function get_paypal_client_id() {
    return "AXQ-_CepIC54TK7KiB8nQzLHNlYDWInNzeep1wBxItL-_musDVcn-sydiJU6FFQRk0O4RKP8Zq00lff2"
}

function get_recaptcha() {
    return "6LezjPkqAAAAAABYhkZrPXx0KbeybKrfywOmJHho"
}

export const config = {
    get_remote_api,
    is_debug_mode,
    get_app_name,
    get_app_version,
    get_app_version_string,
    get_mqtt_server_address,
    get_mqtt_server_port,
    get_public_media,
    get_paypal_client_id,
    get_recaptcha
};

